import { webApi } from '@mi-front/api-clients';

/** Poll interval while at least one project has `renderJob.isPending`. */
const VIDEO_EDITIONS_PROJECT_LIST_REFETCH_MS = 5000;

/**
 * Lists video editor projects for a fragment; refetches on an interval only while a render job is pending.
 */
export function useFragmentVideoEditionsProjectsQuery(fragmentId: string) {
  return webApi.useListProjectsVideoEditorProjects(
    { fragmentId },
    {
      query: {
        refetchInterval: (query) => {
          const data = query.state.data;
          if (!data?.length) return false;
          return data.some((p) => p.renderJob?.isPending === true)
            ? VIDEO_EDITIONS_PROJECT_LIST_REFETCH_MS
            : false;
        },
      },
    },
  );
}
